import React from "react";

const LocationIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 0C3.72188 0 1.875 1.84688 1.875 4.125C1.875 6.40313 6 12 6 12C6 12 10.125 6.40313 10.125 4.125C10.125 1.84688 8.27813 0 6 0ZM6 6.75C4.54922 6.75 3.375 5.57578 3.375 4.125C3.375 2.67422 4.54922 1.5 6 1.5C7.45078 1.5 8.625 2.67422 8.625 4.125C8.625 5.57578 7.45078 6.75 6 6.75ZM6 5.25C6.62109 5.25 7.125 4.74609 7.125 4.125C7.125 3.50391 6.62109 3 6 3C5.37891 3 4.875 3.50391 4.875 4.125C4.875 4.74609 5.37891 5.25 6 5.25Z"
      fill="#545454"
    />
  </svg>
);

export default LocationIcon;
